<div class="dialog-container">
    <div class="dialog-header">
        <div class="left-section">
            <div class="heading">{{ 'changePlanConfirmationTitle' | translate }}</div>
        </div>
        <div class="right-section">
            <div class="close-icon">
                <app-icon path="assets/images/common/cross-icon.svg" (click)="onClose()"></app-icon>
            </div>
        </div>
    </div>

    <div class="dialog-content">
        <div class="summary-card section-bordered-shadow">
            <div class="summary-title">{{ data.title }}</div>
            <div class="summary-price">
                {{ data.price | currencyFormat }}
                <span>/{{ data.per }}</span>
            </div>
            <div class="summary-meta">
                <div class="meta-item"><span>{{ data.users }}</span> {{ 'users' | translate}}</div>
                <div class="meta-item"><span>{{ data.location }}</span> {{ 'location' | translate}}</div>
            </div>
            <ul>
                @for (point of data.detail; track point) {
                <li>
                    <img src="assets/images/settings/tick-green.svg" alt="">
                    {{ point }}
                </li>
                }
            </ul>
        </div>

        <div class="grand-total-card">
            <div class="label">{{ 'totalPayableAmount' | translate }}</div>
            <div class="value">{{ data.price | currencyFormat }}</div>
        </div>

        <div class="payment-method-section">
            <div class="section-heading">{{ 'paymentMethods' | translate}}</div>

            <div class="payment-methods">
                @for (method of paymentMethods; track method) {
                <label class="particular-payment-method" [class.selected]="selectedPaymentMethodId === method.id">
                    <div class="left-content">
                        <input type="radio" name="paymentMethod" [value]="method.id" [(ngModel)]="selectedPaymentMethodId">
                        <div class="icon-section">
                            <img src="assets/images/settings/billing-white-icon.svg" alt="">
                        </div>
                        <div class="content-section">
                            <div class="title">**** **** **** {{ method.card.last4 }}</div>
                            <div class="description">
                                {{ 'expiresAt' | translate : { date: `${method.card.exp_month}/${method.card.exp_year}` } }}
                            </div>
                        </div>
                        @if(method.isDefault || paymentMethods.length === 1){
                        <span class="status-badge blue">{{'default' | translate}}</span>
                        }
                    </div>
                </label>
                }
            </div>
        </div>
    </div>

    <div class="dialog-footer">
        <button class="rounded-btn black" (click)="onClose()">{{ 'cancel' | translate}}</button>
        <button class="rounded-btn primary-gradient" (click)="onConfirm()">{{ 'confirmChange' | translate}}</button>
    </div>
</div>
